exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nhtml,\nbody,\n.container-table {\n  background-color: #ecf0f5;\n}\n.login-bg {\n  background-color: #d2d6de;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n}\n.container-table {\n  display: table;\n  color: white;\n}\n.vertical-center-row {\n  display: table-cell;\n  vertical-align: middle;\n}\n.vertical-20p {\n  padding-top: 20%;\n}\n.vertical-10p {\n  padding-top: 5%;\n}\n.logo {\n  width: 10em;\n  padding: 3em;\n}\n.loginForm .input-group {\n  padding-bottom: 1em;\n  height: 4em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-68292f04","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = 379
// module chunks = 1